import { useState } from 'react';
import './ActiveCallBar.css';

const DIALPAD_KEYS = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['*', '0', '#'],
];

function formatDuration(seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

export default function ActiveCallBar({
  phoneNumber,
  callDuration,
  isMuted,
  onToggleMute,
  onSendDigits,
  onSendToVoicemail,
  sendingVoicemail,
  onHangup,
}) {
  const [showDialpad, setShowDialpad] = useState(false);
  const [dtmfDisplay, setDtmfDisplay] = useState('');
  const [showTransfer, setShowTransfer] = useState(false);

  const handleDigitPress = (digit) => {
    onSendDigits(digit);
    setDtmfDisplay((prev) => prev + digit);
  };

  return (
    <div className="active-call-bar">
      <div className="active-call-bar-main">
        <div className="active-call-bar-info">
          <span className="active-call-bar-icon">&#128222;</span>
          <span className="active-call-bar-number">Calling: {phoneNumber}</span>
          <span className="active-call-bar-duration">{formatDuration(callDuration)}</span>
        </div>

        <div className="active-call-bar-controls">
          <button
            className={`acb-btn acb-btn-mute ${isMuted ? 'acb-btn-muted' : ''}`}
            onClick={onToggleMute}
          >
            {isMuted ? 'Unmute' : 'Mute'}
          </button>

          <button
            className={`acb-btn acb-btn-dialpad ${showDialpad ? 'acb-btn-active' : ''}`}
            onClick={() => setShowDialpad((prev) => !prev)}
          >
            Dialpad
          </button>

          <button
            className={`acb-btn acb-btn-transfer ${showTransfer ? 'acb-btn-active' : ''}`}
            onClick={() => setShowTransfer((prev) => !prev)}
          >
            Transfer
          </button>

          <button
            className="acb-btn acb-btn-recording"
            disabled
            title="Coming soon — requires backend support"
          >
            Pause Rec
          </button>

          <button
            className="acb-btn acb-btn-voicemail"
            onClick={onSendToVoicemail}
            disabled={sendingVoicemail}
          >
            {sendingVoicemail ? 'Sending...' : 'Send to VM'}
          </button>

          <button className="acb-btn acb-btn-hangup" onClick={onHangup}>
            Hang Up
          </button>
        </div>
      </div>

      {showDialpad && (
        <div className="active-call-bar-dialpad">
          <div className="dialpad-grid">
            {DIALPAD_KEYS.map((row, rowIdx) => (
              <div key={rowIdx} className="dialpad-row">
                {row.map((key) => (
                  <button
                    key={key}
                    className="dialpad-key"
                    onClick={() => handleDigitPress(key)}
                  >
                    {key}
                  </button>
                ))}
              </div>
            ))}
          </div>
          {dtmfDisplay && (
            <div className="dtmf-display">{dtmfDisplay}</div>
          )}
        </div>
      )}

      {showTransfer && (
        <div className="active-call-bar-transfer">
          <input
            className="transfer-input"
            type="text"
            placeholder="Phone number or extension"
            disabled
          />
          <div className="transfer-actions">
            <button className="acb-btn acb-btn-transfer-go" disabled>
              Transfer <span className="coming-soon-badge">Coming Soon</span>
            </button>
            <button
              className="acb-btn acb-btn-transfer-cancel"
              onClick={() => setShowTransfer(false)}
            >
              Cancel
            </button>
          </div>
          <span className="transfer-note">Transfer requires backend support — coming soon</span>
        </div>
      )}
    </div>
  );
}
